// ConfirmationAlert.js

import React from 'react';
import './ConfirmationAlert.css';
import BorderButton from '../../material3/components/BorderButton';
import Button from '../../material3/components/Button';

const ConfirmationAlert = ({ onClose, onConfirm }) => {
    return (
        <div className="confirmation-modal">
            <div className="confirmation-content">
                <p className='alert-title'>Delete Confirmation?</p>
                <br/>
                <p>Are you sure you want to delete your account? This action is irreversible and will permanently remove all your account data. Please confirm to proceed.</p>
                <div className='action-button-container'>
                    <BorderButton text="Cancel" onClick={onClose}/>
                    <Button text="Confirm Deletion" onClick={onConfirm}/>
                    &nbsp;
                </div>
            </div>
        </div>
    );
};

export default ConfirmationAlert;
